import objectFitPolyfill from '../bundle/objectFitPolyfill.js';

var objectFit = new objectFitPolyfill();

$(document).ready(function(){
    $(".js-ccc-open").on('click', function(e){
      CookieControl.open();
    });
    $(".secondary-navigation .hasdropdown .non-link").on("click", function(e) {
        e.preventDefault();
        var state = $(this).parent().find(".dropdown").hasClass("active");
        $(".hasdropdown .dropdown").removeClass("active");
        $(this).parent().find(".dropdown").toggleClass("active", !state);
        $(".hasdropdown").removeClass("active");
        $(this).toggleClass("active", !state);
    });
    $(".main-navigation .hasdropdown .non-link").on("click", function(e) {
        e.preventDefault();
        var state = $(this).parent().find(".dropdown").hasClass("active");
        $(".hasdropdown .dropdown").removeClass("active");
        $(this).parent().find(".dropdown").toggleClass("active", !state);
        $(".hasdropdown").removeClass("active");
        $(this).toggleClass("active", !state);
    });
    $(".mobile-navigation .opener").on("click", function() {
        $(this).find(".mobile-dropdown").toggleClass("active");
        $(this).parent().find(".language").removeClass("active");
        $(this).parent().find(".language .mobile-dropdown").removeClass("active");
        $(this).toggleClass("active");
    });
    $(".mobile-navigation .hasdropdown .non-link").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().find(".mobile-sub-dropdown").toggleClass("active");
        $(this).parent().toggleClass("active");
    });
    $(document).on("click", function(e) {
        if($(e.target).closest(".secondary-navigation").length == 0) {
            $(".secondary-navigation .dropdown").removeClass("active");
            $(".secondary-navigation .non-link").removeClass("active");
        }
        if($(e.target).closest(".main-navigation").length == 0) {
            $(".main-navigation .dropdown").removeClass("active");
            $(".main-navigation .non-link").removeClass("active");
        }
    });

    $(".accordion .opener.not-empty").on("click", function() {
        var text = $(this).parent().find(".text");
        $(this).toggleClass("active");
        text.slideToggle("fast");
    });

    $(".search-accordion .opener .open").addClass("active");

    $(".search-accordion .opener").on("click", function(){
        var content = $(this).parent().find(".content");
        $(this).toggleClass("active");
        content.slideToggle("fast");
        if($(this).find(".open").attr("class").indexOf("active") > -1){
            $(this).find(".close").addClass("active");
            $(this).find(".open").removeClass("active");
        }
        else{
            $(this).find(".close").removeClass("active");
            $(this).find(".open").addClass("active");
        }
    });

    function select(){
        $(".select .state").each(function(){
            var defaultState = $(this).parent().find("select").val();
            $(this).html(defaultState);
            $(".select select").on("change", function(){
                $(this).parent().find(".state").html($(this).val())
            });
        });

        $(".select .state-extended").each(function(){
            var defaultState = $(this).parent().find("option:selected").text();
            $(this).html(defaultState);
            $($(this).parent().find("select option")[0]).prop("disabled", true);
            $(".select select").on("change", function(){
                $(this).parent().find(".state-extended").html($(this).find("option:selected").text())
            });
        });
    }

    function anchorSections(){
        var anchorSections = [];
        var anchorSectionLinks = [];

        $(".anchor-sections .anchor-section").map(function(i, e){
            anchorSections.push($(e));
            $(this).attr("data-index", i);
        });

        $(".anchor-navigation a").map(function(i, e){
            anchorSectionLinks.push($(e));
            $(this).attr("data-index", i);
        });

        $(".anchor-navigation a").on("click", function(e){
            e.preventDefault();
            var index = $(this).data("index");
            $("html, body").animate({scrollTop: $(anchorSections[index]).offset().top}, 500);
        });
    }

    function customSelect(){
        $(".select.custom").on("click", function(){
            $(this).find(".checkbox-wrapper").toggleClass("active");
            $(this).toggleClass("active");
        });

        $(document).on("click", function(e) {
            if($(e.target).closest(".select.custom").length == 0) {
                $(".checkbox-wrapper").removeClass("active");
                $(".select.custom").removeClass("active");
            }
        });

        $(".select.custom label input").on("click", function(){
            $(this).parent().parent().toggleClass("checked");
        });
    }

    function playVideo(){
        $(".media .overlay").on("click", function(){
            $(this).css("display", "none");
            document.getElementById('video').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}','*');
        });
    }

    function loadMore(){
        $(".load-more").on("click", function(){
            var button = $(this);
            var index = parseInt($(this).data("next-page"));
            $.get(($(this).data('url')+'?page='+index), function(data, status){
                $(".ajax-load").append(data.html);
                if(data.has_next){
                    index++;
                    $(button).data("next-page", index);
                    objectFit.check();
                }
                else{
                    $(button).remove();
                }
            });
        });
    }

    $('#homepage-filters .select select[name=estate_type_parent]').on('change', function(){
        $(this).find('option:disabled').remove();
    })

    select();
    anchorSections();
    customSelect();
    playVideo();
    loadMore();

});



// WEBPACK FOOTER //
// src/js/bundle/defaults.js